import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirm-privacy-modal',
  templateUrl: './confirm-privacy-modal.component.html',
  styleUrls: ['./confirm-privacy-modal.component.css']
})
export class ConfirmPrivacyModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmPrivacyModalComponent>,
  ) { }

  ngOnInit() {
    document.cookie = 'isConfirmPrivacy=true';
  }

  closePoup() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/confirm-privacy-modal/confirm-privacy-modal.component.ts